<div class="list-page kapea" style="max-width: 1200px">
  <h2>Asiakkaan APIX-tiedot</h2>

  <div style="padding-left: 3em; padding-right: 3em">
    <h3 style="margin: 2em 0">Sopimukset</h3>

    @if (!ladattu()) {
      <mat-progress-bar style="margin: 2em 0" mode="indeterminate"></mat-progress-bar>
    }

    <app-secondary-button (click)="disableAllContracts()" actionId="Lopeta kaikki asiakkaan APIX-sopimukset" styles="margin-bottom: 2em;"> Lopeta kaikki asiakkaan APIX-sopimukset </app-secondary-button>

    <table style="width: 100%">
      <thead>
        <tr>
          <th style="width: 100px">Sopimus</th>
          <th style="width: 100px">Tila</th>
          <th>Parametrit</th>
        </tr>
      </thead>
      <tbody>
        @for (sopimus of sopimuksetObservable | async; track sopimus) {
          <tr>
            <td>{{ sopimus.ContractType }}</td>
            <td style="text-align: center">{{ sopimus.ContractStatus }}</td>
            <td>{{ sopimus.Parameters | ljson }}</td>
          </tr>
        }
      </tbody>
    </table>

    <h3 style="margin: 2em 0">Lähetetyt laskut</h3>
    @for (lasku of laskutObservable | async; track lasku) {
      <div [style.visibility]="ladattu() ? 'visible' : 'hidden'">Laskun {{ lasku?.invoiceNumber }} lähetystyyppi: {{ lasku?.type }}, status: {{ lasku?.status }}</div>
    }
    <div style="margin-bottom: 1em">&nbsp;</div>
    <h3 [style.visibility]="ladattu() ? 'visible' : 'hidden'">Raakadata:</h3>
    <div [style.visibility]="ladattu() ? 'visible' : 'hidden'" [innerHTML]="laskutObservable | async | ljson"></div>
  </div>
</div>
